import { Box, Image } from '@domain-group/suit-theme'

import usePublication from '@hooks/usePublication'

import type { PublicationModel } from '@models/types'

import placeholderImageUrl from './assets/placeholder.svg'

interface PublicationLogoProps {
  boxProps?: object,
  height?: number,
  publication: PublicationModel,
  width?: number,
}

const PublicationLogo = (props: PublicationLogoProps) => {
  const {
    boxProps,
    height = 60,
    publication,
    width = 104,
  } = props

  const publicationPayload = usePublication(publication)
  const { logoUrl } = publicationPayload

  return (
    <Box
      borderRadius={5}
      border="1px solid"
      borderColor="lineColor"
      height={height}
      overflow="hidden"
      width={width}
      {...boxProps}
    >
      <Image
        backgroundSize="contain"
        // @ts-expect-error TS2322
        border="1px solid"
        borderColor="lineColor"
        borderRadius={5}
        placeholderUrl={placeholderImageUrl}
        url={logoUrl}
        height={height - 1}
        width={width - 1}
      />
    </Box>
  )
}

export default PublicationLogo
